module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.quantity), function(star) {
    return (_vm.show) ? _c('i', {
      staticClass: "material-icons star"
    }, [_vm._v("star")]) : _vm._e()
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-96e1a9f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/StarPower.vue
// module id = 52
// module chunks = 0